import { $session } from "./session.js";
import { $cookies } from "./cookies.js";

const $router = 
{
	// 라우트 이동시 세션 처리
    setBeforeEach(router) 
    {
		router.beforeEach(async(to, from, next) => {

			// (1) 권한 체크를 하지 않아도 되는 경우
			if (to.matched.some(record => record.meta.auth == false)) {
				return next();
			} 
			
			// (2) 권한 체크를 하는 경우
			if (to.matched.some(record => record.meta.auth == true)) {
				let accessToken = $cookies.get("ACCESS_TOKEN");
				let refreshToken = $cookies.get("REFRESH_TOKEN");
		
				console.log("* access token=" + accessToken);
				console.log("* refresh token=" + refreshToken);
	
				// (1) 엑세스토큰이 존재하는 경우는 통과
				if (accessToken) {
					return next();
				}

				// (2) 토큰 재발급 처리 (by Refresh 토큰) 
				if (accessToken == null && refreshToken != null) {
					$session.callRefreshToken();
				}

				// (3) 토큰이 존재하지 않는 경우
				if (accessToken == null && refreshToken == null) {
					console.log("1. 권한이 존재하는 메뉴이고 access/refresh 토큰 미존재");
					alert("Plean sign in again(1) !");
					location.href = $session.getSignInUrl();
				}
			}

			return next();
		})
    }
}

export {
    $router
}
